const baseUrl = ""
export const ApiPaths = {
  BASE_URL: baseUrl,
  FILE_UPLOAD_MULTI: "storage/upload/files",
  FILE_UPLOAD_IMAGES: "storage/upload/images",
  FILE_UPLOAD_PDFS: "storage/upload/pdfs",
  // FILE_UPLOAD_MULTI: "https://upload.aauti.com/file/multiUpload",
  GET_INVOICE_LIST: "invoice/getAll",
  UPDATE_EVENT_STATUS: "schedule/updateStatus",
}
